module.exports = __webpack_public_path__ + "img/shouye_meiri@2x.6051cd4f.png";